import styled from 'styled-components';

export default styled.div`
  min-height: 3.8rem;
  display: grid;
  grid-template-columns: ${({ cols }) => cols || 'auto 1fr auto'};
  justify-content: center;
  align-content: center;
`;
